export default "__VITE_ASSET__cafc69ad__"